(function () {
  'use strict';

  /* ─── CSS ────────────────────────────────────────────────────────────────── */
  var CSS = [
    '.jn-sc-ov{position:fixed;inset:0;z-index:100000;background:rgba(0,0,0,0);display:flex;align-items:stretch;justify-content:flex-end;transition:background .28s}',
    '.jn-sc-ov.open{background:rgba(26,23,20,.52)}',
    '.jn-sc-panel{background:#ffffff;width:min(480px,100vw);height:100dvh;transform:translateX(100%);transition:transform .32s cubic-bezier(.4,0,.2,1);display:flex;flex-direction:column;overflow:hidden}',
    '.jn-sc-ov.open .jn-sc-panel{transform:translateX(0)}',
    '@media(min-width:769px){',
    '.jn-sc-ov{align-items:center;justify-content:center}',
    '.jn-sc-panel{width:min(700px,92vw);height:auto;max-height:90vh;border-radius:2px;transform:translateY(12px);transition:transform .3s ease,opacity .3s ease;opacity:0}',
    '.jn-sc-ov.open .jn-sc-panel{transform:translateY(0);opacity:1}',
    '}',
    '.jn-sc-hd{position:sticky;top:0;z-index:2;background:#ffffff;border-bottom:1px solid #e1e1e1;padding:14px 20px;display:flex;align-items:center;justify-content:space-between}',
    '.jn-sc-ttl{font-size:10px;letter-spacing:.22em;text-transform:uppercase;color:#57595b;font-weight:500;font-family:"Inter",sans-serif}',
    '.jn-sc-x{background:none;border:none;cursor:pointer;font-size:22px;color:#939393;padding:0 0 0 12px;line-height:1;font-family:inherit;transition:color .2s}',
    '.jn-sc-x:hover{color:#3c1053}',
    '.jn-sc-body{padding:14px 24px 22px;flex:1;min-height:0;overflow-y:auto;-webkit-font-smoothing:antialiased}',
    '@media(min-width:769px){.jn-sc-body{flex:0 1 auto}}',
    /* quiz note */
    '.jn-sc-quiz{display:block;font-size:11px;font-family:"Inter",sans-serif;color:#3c1053;text-align:right;text-decoration:none;margin-bottom:14px;letter-spacing:.02em}',
    '.jn-sc-quiz:hover{text-decoration:underline}',
    /* your size box */
    '.jn-sc-ys{background:#f6f6f6;border:1px solid #e1e1e1;padding:16px 18px 14px}',
    '.jn-sc-ys-lbl{font-size:9px;letter-spacing:.20em;text-transform:uppercase;color:#a899ba;margin-bottom:4px;font-family:"Inter",sans-serif}',
    '.jn-sc-ys-sys{opacity:.6}',
    '.jn-sc-ys-big{font-family:"Cormorant Garamond",serif;font-size:52px;line-height:1;color:#57595b;font-weight:300;letter-spacing:-.01em;margin-bottom:5px}',
    '.jn-sc-ys-sis{font-size:11px;font-family:"Inter",sans-serif;color:#a899ba;margin:4px 0 12px}',
    '.jn-sc-ys-sis span{display:inline-block;padding:3px 12px;border:1px solid #e1e1e1;margin:3px 3px 3px 0;font-family:"Cormorant Garamond",serif;font-size:14px;color:#57595b}',
    /* not-your-size / understanding-fit buttons row */
    '.jn-sc-ys-btns{display:flex;gap:10px;flex-wrap:wrap;padding-top:4px}',
    '.jn-sc-recalc{display:inline-flex;align-items:center;gap:8px;padding:9px 16px;border:1.5px solid #3c1053;background:transparent;color:#3c1053;cursor:pointer;font-size:10px;letter-spacing:.14em;text-transform:uppercase;font-family:"Inter",sans-serif;transition:all .2s;line-height:1}',
    '.jn-sc-recalc:hover{background:#3c1053;color:#fff}',
    '.jn-sc-recalc-ico{display:inline-block;transition:transform .25s;line-height:0}',
    '.jn-sc-recalc.open .jn-sc-recalc-ico{transform:rotate(180deg)}',
    /* find section */
    '.jn-sc-find{padding-top:14px;margin-top:4px}',
    '.jn-sc-find-ttl{font-size:9px;letter-spacing:.20em;text-transform:uppercase;color:#a899ba;margin-bottom:14px;font-family:"Inter",sans-serif}',
    /* choice cards */
    '.jn-sc-cards{display:grid;grid-template-columns:1fr 1fr;gap:14px;margin-bottom:4px}',
    '@media(max-width:400px){.jn-sc-cards{grid-template-columns:1fr}}',
    '.jn-sc-card{padding:24px 14px;background:#fff;border:1.5px solid #e1e1e1;cursor:pointer;text-align:center;transition:border-color .2s,background .2s,transform .2s}',
    '.jn-sc-card:hover{border-color:#3c1053;background:#f6f6f6;transform:translateY(-2px)}',
    '.jn-sc-card-ico{font-size:22px;margin-bottom:8px}',
    '.jn-sc-card-ttl{font-family:"Cormorant Garamond",serif;font-size:17px;font-weight:400;margin-bottom:5px;color:#57595b}',
    '.jn-sc-card-sub{font-size:11px;color:#939393;line-height:1.55;font-family:"Inter",sans-serif}',
    /* form back link */
    '.jn-sc-back{background:none;border:none;cursor:pointer;font-size:11px;color:#939393;padding:0 0 14px;display:inline-flex;align-items:center;gap:4px;font-family:"Inter",sans-serif;letter-spacing:.04em;transition:color .2s}',
    '.jn-sc-back:hover{color:#57595b}',
    /* selects */
    '.jn-sc-sels{display:grid;grid-template-columns:1fr 1fr;gap:14px;margin-bottom:14px}',
    '.jn-sc-sw label{display:block;font-size:9px;letter-spacing:.18em;text-transform:uppercase;color:#939393;margin-bottom:6px;font-family:"Inter",sans-serif}',
    '.jn-sc-sel{width:100%;padding:12px 32px 12px 14px;border:1.5px solid #e1e1e1;font-family:"Cormorant Garamond",serif;font-size:22px;color:#57595b;background:#fff url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'11\' height=\'7\' viewBox=\'0 0 11 7\'%3E%3Cpath d=\'M1 1l4.5 4.5L10 1\' stroke=\'%23939393\' fill=\'none\' stroke-width=\'1.5\' stroke-linecap=\'round\'/%3E%3C/svg%3E") no-repeat right 12px center;-webkit-appearance:none;appearance:none;outline:none;cursor:pointer;transition:border-color .2s}',
    '.jn-sc-sel:focus{border-color:#3c1053}',
    /* unit toggle */
    '.jn-sc-units{display:flex;margin-bottom:14px;width:-moz-fit-content;width:fit-content;border:1.5px solid #e1e1e1}',
    '.jn-sc-ubtn{padding:7px 20px;background:#fff;border:none;cursor:pointer;font-size:10px;letter-spacing:.12em;text-transform:uppercase;color:#939393;transition:all .2s;font-family:"Inter",sans-serif}',
    '.jn-sc-ubtn+.jn-sc-ubtn{border-left:1.5px solid #e1e1e1}',
    '.jn-sc-ubtn.active{background:#3c1053;color:#fff}',
    /* measure images + inputs */
    '.jn-sc-imgs{display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:14px}',
    '.jn-sc-iw img{width:100%;aspect-ratio:3/2;object-fit:cover;display:block;background:#f6f6f6}',
    '.jn-sc-ilbl{font-size:9px;letter-spacing:.12em;text-transform:uppercase;background:rgba(60,16,83,.72);color:#fff;padding:5px 8px;text-align:center;font-family:"Inter",sans-serif}',
    '.jn-sc-inps{display:grid;grid-template-columns:1fr 1fr;gap:14px;margin-bottom:12px}',
    '.jn-sc-iw2 label{display:block;font-size:9px;letter-spacing:.18em;text-transform:uppercase;color:#939393;margin-bottom:6px;font-family:"Inter",sans-serif}',
    '.jn-sc-inp{width:100%;padding:12px;border:1.5px solid #e1e1e1;font-family:"Cormorant Garamond",serif;font-size:28px;text-align:center;background:#fff;color:#57595b;outline:none;transition:border-color .2s;-moz-appearance:textfield;box-sizing:border-box}',
    '.jn-sc-inp::-webkit-inner-spin-button{-webkit-appearance:none}',
    '.jn-sc-inp:focus{border-color:#3c1053}',
    '.jn-sc-err{font-size:11px;font-family:"Inter",sans-serif;color:#c0392b;min-height:16px;margin-bottom:8px}',
    /* CTA */
    '.jn-sc-cta{display:block;width:100%;padding:14px;background:#3c1053;color:#fff;border:none;cursor:pointer;font-size:10px;letter-spacing:.18em;text-transform:uppercase;transition:background .2s;font-family:"Inter",sans-serif}',
    '.jn-sc-cta:hover:not(:disabled){background:#2d0c3e}',
    '.jn-sc-cta:disabled{opacity:.3;cursor:not-allowed}',
    /* result box */
    '.jn-sc-res{background:#f6f6f6;border:1px solid #e1e1e1;padding:20px;margin-top:14px;text-align:center}',
    '.jn-sc-res-lbl{font-size:9px;letter-spacing:.20em;text-transform:uppercase;font-family:"Inter",sans-serif;color:#a899ba;margin-bottom:4px}',
    '.jn-sc-res-sz{font-family:"Cormorant Garamond",serif;font-size:56px;line-height:1;color:#57595b;font-weight:300;margin-bottom:4px}',
    '.jn-sc-res-sub{font-size:12px;font-family:"Inter",sans-serif;color:#a899ba;margin-bottom:8px}',
    '.jn-sc-sis-bd{display:inline-block;padding:3px 12px;border:1px solid #e1e1e1;margin:3px;font-family:"Cormorant Garamond",serif;font-size:14px;color:#57595b}',
    /* chart */
    '.jn-sc-chart{margin-top:12px;border-top:1px solid #e1e1e1;padding-top:12px}',
    '.jn-sc-chart-ttl{font-size:9px;letter-spacing:.20em;text-transform:uppercase;font-family:"Inter",sans-serif;color:#939393;margin-bottom:10px}',
    '.jn-sc-sys{display:flex;gap:6px;margin-bottom:10px;flex-wrap:wrap}',
    '.jn-sc-stab{padding:5px 14px;border:1.5px solid #e1e1e1;background:#fff;font-size:10px;letter-spacing:.1em;text-transform:uppercase;cursor:pointer;color:#939393;transition:all .2s;font-family:"Inter",sans-serif}',
    '.jn-sc-stab.active{border-color:#3c1053;color:#3c1053;background:#f6f6f6}',
    '.jn-sc-tscroll{overflow-x:auto;-webkit-overflow-scrolling:touch}',
    '.jn-sc-tbl{width:100%;border-collapse:collapse;font-size:13px;min-width:200px}',
    '.jn-sc-tbl th{text-align:left;padding:8px 12px;background:#f6f6f6;border-bottom:2px solid #e1e1e1;font-size:9px;letter-spacing:.14em;text-transform:uppercase;font-family:"Inter",sans-serif;color:#939393;font-weight:500}',
    '.jn-sc-tbl td{padding:8px 12px;border-bottom:1px solid #e1e1e1;color:#57595b;vertical-align:top}',
    '.jn-sc-tbl tr.jn-sc-hl td{background:#efefef;border-left:3px solid #3c1053;color:#3c1053;font-weight:500}',
    '.jn-sc-tbl tr.jn-sc-hl td:first-child{padding-left:9px}',
    '.jn-sc-you{display:inline-block;background:#3c1053;color:#fff;font-size:8px;letter-spacing:.1em;text-transform:uppercase;padding:2px 5px;margin-left:5px;vertical-align:middle;font-family:"Inter",sans-serif}',
    '.jn-sc-empty{padding:16px 0;color:#939393;font-size:13px;font-family:"Inter",sans-serif}',
    /* how to measure */
    '.jn-sc-how{border-top:1px solid #e1e1e1;padding-top:14px;margin-top:14px}',
    '.jn-sc-how-hd{display:flex;align-items:center;justify-content:space-between;cursor:pointer;padding-bottom:10px;-webkit-user-select:none;user-select:none}',
    '.jn-sc-how-ttl{font-size:10px;letter-spacing:.16em;text-transform:uppercase;color:#57595b;font-weight:500;font-family:"Inter",sans-serif}',
    '.jn-sc-how-ico{color:#a899ba;transition:transform .25s;line-height:0}',
    '.jn-sc-how-ico.open{transform:rotate(180deg)}',
    '.jn-sc-how-body{padding-bottom:10px}',
    '.jn-sc-how-pair{display:grid;grid-template-columns:1fr 1fr;gap:14px}',
    '@media(max-width:520px){.jn-sc-how-pair{grid-template-columns:1fr;gap:10px}}',
    '.jn-sc-how-lbl{font-size:9px;letter-spacing:.16em;text-transform:uppercase;color:#3c1053;font-weight:500;margin-bottom:4px;font-family:"Inter",sans-serif}',
    '.jn-sc-how-p{font-size:11px;line-height:1.55;color:#939393;margin:0;font-family:"Inter",sans-serif}',
    /* fitter notes */
    '.jn-sc-fnote{background:#f6f6f6;border-left:2px solid #a899ba;padding:14px 18px 16px;margin-top:20px}',
    '.jn-sc-fnote-lbl{font-size:9px;letter-spacing:.24em;text-transform:uppercase;color:#3c1053;margin-bottom:7px;font-family:"Inter",sans-serif}',
    '.jn-sc-fnote-q{font-family:"Cormorant Garamond",serif;font-size:15px;font-style:italic;font-weight:400;line-height:1.65;color:#57595b;margin:0;padding:0;border:none}',
    /* fit guide accordion */
    '.jn-sc-fit-body{border-top:1px solid #e1e1e1;padding:14px 0 6px;margin-top:6px}',
    '.jn-sc-fit-sl{font-size:9px;letter-spacing:.20em;text-transform:uppercase;color:#939393;margin:0 0 8px;font-family:"Inter",sans-serif}',
    '.jn-sc-fit-tips{list-style:none;padding:0;margin:0}',
    '.jn-sc-fit-tips li{font-size:12px;font-family:"Inter",sans-serif;color:#57595b;line-height:1.55;padding:6px 0 6px 14px;position:relative;border-bottom:1px solid #e1e1e1}',
    '.jn-sc-fit-tips li:last-child{border-bottom:none}',
    '.jn-sc-fit-tips li::before{content:"→";position:absolute;left:0;color:#3c1053;font-size:10px;top:8px;line-height:1}',
    /* shape grid */
    '.jn-sc-shapes{display:grid;grid-template-columns:repeat(3,1fr);gap:10px;margin-top:10px}',
    '@media(max-width:400px){.jn-sc-shapes{grid-template-columns:repeat(2,1fr)}}',
    '.jn-sc-sh-card{text-align:center}',
    '.jn-sc-sh-iw{background:#3c1053;aspect-ratio:1;overflow:hidden;margin-bottom:5px}',
    '.jn-sc-sh-img{width:100%;height:100%;object-fit:contain;display:block}',
    '.jn-sc-sh-name{font-family:"Cormorant Garamond",serif;font-size:13px;color:#57595b;margin-bottom:2px;font-weight:400}',
    '.jn-sc-sh-tip{font-size:10px;font-family:"Inter",sans-serif;color:#939393;line-height:1.45}',
    /* US equivalent annotation on highlighted chart row */
    '.jn-sc-us-eq{font-size:11px;color:#939393;font-family:"Inter",sans-serif;margin:0 6px 0 3px;font-weight:400}',
    /* native-size hint below the big US size in the Your Size box */
    '.jn-sc-ys-hint{font-size:12px;font-family:"Inter",sans-serif;color:#a899ba;margin:-2px 0 8px;letter-spacing:.01em}',
    /* entry system selector label */
    '.jn-sc-esys-lbl{font-size:9px;letter-spacing:.18em;text-transform:uppercase;color:#939393;margin-bottom:8px;font-family:"Inter",sans-serif}',
    /* dress size calculator */
    '.jn-sc-inps-3{grid-template-columns:repeat(3,1fr)}',
    '@media(max-width:480px){.jn-sc-inps-3{grid-template-columns:1fr 1fr}}',
    '.jn-sc-dr-tip{margin:5px 0 0;font-size:10px;color:#939393;font-family:"Inter",sans-serif;line-height:1.4}',
    /* trigger */
    '.jn-sc-wrap{display:inline-flex;align-items:center}',
    '.jn-sc-btn{background:none;border:none;cursor:pointer;font-size:inherit;color:#3c1053;text-decoration:underline!important;text-underline-offset:2px;padding:0;font-family:inherit;white-space:nowrap;letter-spacing:.03em}',
    '.jn-sc-btn:hover{color:#57595b}',
    '.jn-sc-btn:active,.jn-sc-btn:focus{color:#3c1053;outline:none}'
  ].join('');

  /* ─── SIZE CONVERSION ────────────────────────────────────────────────────── */
  var CUPS    = ['AA','A','B','C','D','DD','DDD','F','G','H','I','J','K']; // US cups
  var CUPS_UK = ['AA','A','B','C','D','DD','E','F','FF','G','GG','H','HH']; // UK/AU cups
  var CUPS_EU = ['AA','A','B','C','D','E','F','G']; // Italian/French cups (no DD, D→E)

  var SHAPE_BASE = 'https://cdn.shopify.com/s/files/1/1658/2831/files/';
  var SHAPES = [
    {n:'Teardrop',    f:'BreastShapes_0005_teardrop.png?v=1770240760',    t:'Fullness on the bottom; cups can gape at the top. Sweetheart or demi silhouettes with fabric overlays work best.'},
    {n:'Full & Round',f:'BreastShapes_0004_FullRound.png?v=1770241167',   t:'Fullness all over; cups may not fully cover or may dig in. Look for triangle plunge shapes that hug without digging.'},
    {n:'Compact',     f:'BreastShapes_0003_Compapct.png?v=1770241224',    t:'Fullness carried high, cups are small. Contoured padding or dimensional stretch fabrics work well.'},
    {n:'Slender',     f:'BreastShapes_0001_slender.png?v=1770241256',     t:'Fullness on the bottom with less firmness; cups gape when moving. Shallow demis or fabric overlays help elevate.'},
    {n:'Wide Set',    f:'BreastShapes_0002_wide-set.png?v=1770241291',    t:'Fullness on the sides; bras may gape center or dig under the arm. Gently curving underwires and generous spacers.'},
    {n:'Asymmetric',  f:'BreastShapes_0000_Asymmetric.png?v=1770241326',  t:'More fullness on one side — very common. Fit to the larger side; use a removable insert for the other.'}
  ];
  var US_UK = {AA:'AA',A:'A',B:'B',C:'C',D:'D',DD:'DD',DDD:'E',F:'E',G:'F',H:'FF',I:'G',J:'GG',K:'H'};
  var UK_US = {AA:'AA',A:'A',B:'B',C:'C',D:'D',DD:'DD',E:'DDD',F:'G',FF:'H',G:'I',GG:'J',H:'K',HH:'K'};
  var US_EU = {AA:'AA',A:'A',B:'B',C:'C',D:'D',DD:'E',DDD:'F',F:'F',G:'G',H:'H',I:'I',J:'J',K:'K'};
  var EU_US = {AA:'AA',A:'A',B:'B',C:'C',D:'D',E:'DD',F:'DDD',G:'G',H:'H',I:'I',J:'J',K:'K'};

  function parseBra(s) {
    var m = /^(\d{2,3})\s*([A-Za-z]{1,3})$/.exec((s || '').trim());
    return m ? { band: parseInt(m[1], 10), cup: m[2].toUpperCase() } : null;
  }

  function convertBra(size, from, to) {
    if (!from || !to || from === to) return size;
    var p = parseBra(size);
    if (!p) return size;
    var band = p.band, cup = p.cup;
    // Band numbers are the same across all systems used here (US/UK/EU brands on this site
    // all use US-range bands 28-50). Only cup letters differ by system.
    if (from === 'uk')   { cup = UK_US[cup] || cup; }
    if (from === 'euro') { cup = EU_US[cup] || cup; }
    if (to === 'us')   return band + cup;
    if (to === 'uk')   return band + (US_UK[cup] || cup);
    if (to === 'euro') return band + (US_EU[cup] || cup);
    return size;
  }

  // Infer sizing system from cup letters when no size-type tag is set.
  // EU cups go D→E (no DD step). UK cups go D→DD→E. FF/GG/HH only exist in UK/AU.
  function autoDetectSys(rows) {
    var ukDoubles = { FF:1, GG:1, HH:1 }; // exclusive to UK/AU
    var highCups  = { E:1, F:1, G:1, H:1, J:1, K:1 }; // exist in EU and UK (above DD)
    var hasDD = false, hasUkDouble = false, hasHighCup = false, total = 0;
    for (var i = 0; i < rows.length; i++) {
      var p = parseBra(rows[i].s);
      if (!p) continue;
      total++;
      if (p.cup === 'DD') hasDD = true;
      if (ukDoubles[p.cup]) hasUkDouble = true;
      if (highCups[p.cup]) hasHighCup = true;
    }
    if (total === 0) return '';
    if (hasUkDouble) return 'uk';           // FF/GG/HH → definitely UK
    if (hasHighCup && !hasDD) return 'euro'; // E/F/G without DD → EU cup system
    if (hasHighCup) return 'uk';            // DD + E together → UK (DD and E are distinct UK cups)
    return '';                               // US (A through DDD/F only)
  }

  // For products whose SIZE column isn't bra sizes (e.g. XS/S/M/L bralettes whose
  // bra sizes live in the FITS column), detect the cup system from the fit tokens
  // instead. Tokens can be comma-lists and "32DD/E" style — flatten them all.
  function detectSysFromFits(rows) {
    var toks = [];
    (rows || []).forEach(function (r) {
      if (!r.f) return;
      String(r.f).split(',').forEach(function (t) {
        t.trim().split('/').forEach(function (part) {
          part = part.trim();
          if (parseBra(part)) toks.push({ s: part });
        });
      });
    });
    return toks.length ? autoDetectSys(toks) : '';
  }

  // Only show conversion tabs when sizes are standard bra band sizes (28–50")
  function hasValidBraSizing(rows, sys) {
    if (!rows || !rows.length) return false;
    var valid = 0;
    for (var i = 0; i < rows.length; i++) {
      var p = parseBra(rows[i].s);
      if (!p) continue;
      // All systems on this site use US-range bands (28-50); AU dress bands (10-18) are excluded
      if (p.band >= 28 && p.band <= 50) valid++;
    }
    return valid > 0 && valid >= Math.ceil(rows.length / 2);
  }

  /* ─── COOKIE ─────────────────────────────────────────────────────────────── */
  function getCk(n) {
    var c = document.cookie.split(';').map(function(s){ return s.trim(); }).find(function(s){ return s.startsWith(n + '='); });
    return c ? decodeURIComponent(c.slice(n.length + 1)) : null;
  }
  function setCk(n, v, d) {
    document.cookie = n + '=' + encodeURIComponent(v) + ';max-age=' + (d * 86400) + ';path=/;SameSite=Lax';
  }
  function getBra() {
    try { var v = getCk('jfq_bra_sz'); return v ? JSON.parse(v) : null; } catch(e) { return null; }
  }
  function saveBra(sz) {
    setCk('jfq_bra_sz', JSON.stringify({ band: sz.band, cup: sz.cup, full: sz.full }), 365);
  }

  /* ─── CALC ───────────────────────────────────────────────────────────────── */
  function calcBra(band, bust, unit) {
    var b = parseFloat(band), f = parseFloat(bust);
    if (unit === 'cm') { b /= 2.54; f /= 2.54; }
    var bs = Math.round(b);
    if (bs % 2 !== 0) bs++;
    bs = Math.max(28, Math.min(50, bs));
    var cup = CUPS[Math.min(Math.round(Math.max(0, f - b)), CUPS.length - 1)];
    return { band: bs, cup: cup, full: bs + cup };
  }

  function sisters(sz) {
    var ci = CUPS.indexOf(sz.cup), out = [];
    if (sz.band >= 30 && ci < CUPS.length - 1) out.push((sz.band - 2) + CUPS[ci + 1]);
    if (sz.band <= 44 && ci > 0)               out.push((sz.band + 2) + CUPS[ci - 1]);
    return out;
  }

  /* ─── KLAVIYO ────────────────────────────────────────────────────────────── */
  function kTrack(e, p) {
    try { if (window._learnq) window._learnq.push(['track', e, p]); } catch(ex) {}
  }

  /* ─── HELPERS ────────────────────────────────────────────────────────────── */
  function esc(s) {
    return String(s || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }
  function norm(s) { return (s || '').replace(/\s/g,'').toUpperCase(); }

  /* ─── SIZE SORT ──────────────────────────────────────────────────────────── */
  var CLO_ORDER = [
    'xxs','2xs','x-small','xsmall','extra small','extra-small',
    'xs','s','sm','small',
    'm','md','medium',
    'l','lg','large',
    'xl','x-large','xlarge','extra large','extra-large',
    'xxl','2xl','xx-large','xxlarge',
    'xxxl','3xl','xxx-large','xxxlarge',
    'one size','onesize','os'
  ];

  // Unified cup rank covering US, UK, and Euro cup letters in volume order
  var CUP_RANK = {AA:0,A:1,B:2,C:3,D:4,DD:5,E:6,DDD:7,F:8,FF:9,G:10,GG:11,H:12,HH:13,I:14,J:15,JJ:16,K:17};

  function sizeRank(s) {
    var lo = (s || '').toLowerCase().replace(/[^a-z0-9 ]/g, ' ').replace(/\s+/g, ' ').trim();
    var ci = CLO_ORDER.indexOf(lo);
    if (ci !== -1) return ci;
    var p = parseBra(s);
    if (p) return 1000 + p.band * 100 + (CUP_RANK[p.cup] !== undefined ? CUP_RANK[p.cup] : 50);
    var n = parseFloat(s);
    if (!isNaN(n)) return 2000 + n;
    return 9999;
  }

  function sortRows(rows) {
    return rows.slice().sort(function(a, b) {
      return sizeRank(a.s) - sizeRank(b.s);
    });
  }

  var CHEV = '<svg width="10" height="6" viewBox="0 0 10 6" fill="none" style="display:block"><path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* ─── DRESS SIZE DATA ────────────────────────────────────────────────────── */
  var DRESS_SIZES = [
    {n:0,  bust:31.5, waist:24.0, hip:34.5},
    {n:2,  bust:32.5, waist:25.0, hip:35.5},
    {n:4,  bust:33.5, waist:26.0, hip:36.5},
    {n:6,  bust:34.5, waist:27.0, hip:37.5},
    {n:8,  bust:35.5, waist:28.0, hip:38.5},
    {n:10, bust:36.5, waist:29.0, hip:39.5},
    {n:12, bust:38.0, waist:30.5, hip:41.0},
    {n:14, bust:39.5, waist:32.0, hip:42.5},
    {n:16, bust:41.0, waist:33.5, hip:44.0},
    {n:18, bust:43.0, waist:35.5, hip:46.0},
    {n:20, bust:45.0, waist:37.5, hip:48.0},
    {n:22, bust:47.0, waist:39.5, hip:50.0}
  ];

  var DRESS_TO_PANTY = {0:'XS',2:'XS',4:'S',6:'S',8:'M',10:'M',12:'L',14:'L',16:'XL',18:'XL',20:'XXL',22:'XXL'};

  // Returns true when the FITS column (not size column) contains dress size ranges
  function isDressFits(rows) {
    if (!rows || !rows.length) return false;
    var re = /^(\d+)\s*[-–]\s*(\d+)$/;
    var match = 0, total = 0;
    for (var i = 0; i < rows.length; i++) {
      if (!rows[i].f) continue;
      total++;
      var m = re.exec((rows[i].f || '').trim());
      if (m && parseInt(m[1], 10) <= 30 && parseInt(m[2], 10) <= 30) match++;
    }
    return total > 0 && match >= Math.ceil(total / 2);
  }

  // Given a fits string like "4 - 6", returns {waist, hip} measurement strings in inches
  function dressFitsMeasurements(fits) {
    var re = /^(\d+)\s*[-–]\s*(\d+)$/;
    var m = re.exec((fits || '').trim());
    if (!m) return null;
    var lo = parseInt(m[1], 10), hi = parseInt(m[2], 10);
    var loD = null, hiD = null;
    for (var i = 0; i < DRESS_SIZES.length; i++) {
      if (DRESS_SIZES[i].n === lo) loD = DRESS_SIZES[i];
      if (DRESS_SIZES[i].n === hi) hiD = DRESS_SIZES[i];
    }
    if (!loD || !hiD) return null;
    var fmt = function(v) { return v + '”'; }; // e.g. 36.5"
    return {
      waist: loD === hiD ? fmt(loD.waist) : fmt(loD.waist) + '–' + fmt(hiD.waist),
      hip:   loD === hiD ? fmt(loD.hip)   : fmt(loD.hip)   + '–' + fmt(hiD.hip)
    };
  }

  // Returns true when the majority of rows look like dress size ranges: "4-6", "8 - 10" etc.
  function isDressSize(rows) {
    if (!rows || !rows.length) return false;
    var re = /^(\d+)\s*[-–]\s*(\d+)$/;
    var match = 0;
    for (var i = 0; i < rows.length; i++) {
      var m = re.exec((rows[i].s || '').trim());
      if (m && parseInt(m[1], 10) <= 30 && parseInt(m[2], 10) <= 30) match++;
    }
    return match >= Math.ceil(rows.length / 2);
  }

  // Best US dress size given measurements in inches (pass 0 for any dimension not measured)
  // Hip is the primary signal; bust/waist are secondary tiebreakers
  function calcDress(bustIn, waistIn, hipIn) {
    var best = null, bestScore = Infinity;
    for (var i = 0; i < DRESS_SIZES.length; i++) {
      var d = DRESS_SIZES[i], score = 0, count = 0;
      if (hipIn   > 0) { score += Math.abs(d.hip   - hipIn);         count++; }
      if (bustIn  > 0) { score += Math.abs(d.bust  - bustIn)  * 0.6; count++; }
      if (waistIn > 0) { score += Math.abs(d.waist - waistIn) * 0.5; count++; }
      if (!count) continue;
      if (score < bestScore) { bestScore = score; best = d; }
    }
    return best ? best.n : null;
  }

  // Returns the product row size string that contains the calculated dress size number
  function matchDressRow(rows, sizeNum) {
    if (sizeNum === null) return null;
    var re = /^(\d+)\s*[-–]\s*(\d+)$/;
    for (var i = 0; i < rows.length; i++) {
      var m = re.exec((rows[i].s || '').trim());
      if (m) {
        var lo = parseInt(m[1], 10), hi = parseInt(m[2], 10);
        if (sizeNum >= lo && sizeNum <= hi) return rows[i].s;
      }
    }
    return null;
  }

  // For products where the FITS column holds dress ranges, returns the SIZE label (e.g. "Medium")
  function matchDressFitsRow(rows, sizeNum) {
    if (sizeNum === null) return null;
    var re = /^(\d+)\s*[-–]\s*(\d+)$/;
    for (var i = 0; i < rows.length; i++) {
      var m = re.exec((rows[i].f || '').trim());
      if (m) {
        var lo = parseInt(m[1], 10), hi = parseInt(m[2], 10);
        if (sizeNum >= lo && sizeNum <= hi) return rows[i].s;
      }
    }
    return null;
  }

  /* ─── STATE ──────────────────────────────────────────────────────────────── */
  var S = null;

  // Expand "32DD/E" → ["32DD","32E"], "30DDD/F" → ["30DDD","30F"]
  function fitTokenMatches(token, target) {
    var parts = token.split('/');
    var p0 = parseBra(parts[0].trim());
    var leadBand = p0 ? p0.band : null;
    for (var i = 0; i < parts.length; i++) {
      var candidate = parts[i].trim();
      if (i > 0 && leadBand !== null && !parseBra(candidate)) {
        candidate = leadBand + candidate; // cup-only suffix → prepend band
      }
      if (norm(candidate) === norm(target)) return true;
    }
    return false;
  }

  /* ─── HIGHLIGHT ──────────────────────────────────────────────────────────── */
  function isHL(row) {
    if (!S || !S.bra) return false;
    var nativeSys = S.effectiveSys || 'us';
    // Convert cookie (always stored as US) into the product's native sizing system
    var cookieInNative = nativeSys !== 'us' ? convertBra(S.bra.full, 'us', nativeSys) : S.bra.full;
    if (norm(row.s) === norm(cookieInNative)) return true;
    // Check fits column (garments with bra-size fits use native system labels)
    if (row.f) {
      var fits = row.f.split(',');
      for (var i = 0; i < fits.length; i++) {
        if (fitTokenMatches(fits[i].trim(), cookieInNative)) return true;
      }
    }
    return false;
  }

  /* ─── RENDER ─────────────────────────────────────────────────────────────── */
  function render() {
    var app = document.getElementById('jn-sc-app');
    if (!app) return;
    // buildPanty only for underwear products whose SIZE column is NOT numeric dress ranges.
    // Slips and similar non-panty garments have isDressSize rows (e.g. "4-6", "8-10") and
    // need the full bust/waist/hip calculator via buildNonBra instead.
    var usePantyView = S.data.isPanty && !isDressSize(S.data.rows || []);
    app.innerHTML = S.data.isBra ? buildBra() : usePantyView ? buildPanty() : buildNonBra();
  }

  /* ─── BRA ────────────────────────────────────────────────────────────────── */
  function buildBra() {
    var data = S.data, bra = S.bra;
    var h = '';

    h += '<a href="/pages/shopping-help?category=bras" class="jn-sc-quiz" target="_blank">Not sure what size? Take the fit quiz &rarr;</a>';

    if (bra) {
      var sis = sisters(bra);
      var nativeSys = S.effectiveSys || 'us';
      var nativeEq = nativeSys !== 'us' ? convertBra(bra.full, 'us', nativeSys) : '';
      var showNativeHint = nativeEq && norm(nativeEq) !== norm(bra.full);
      var nativeSysName = { uk: 'UK/AU', euro: 'European' };
      h += '<div class="jn-sc-ys">'
        + '<div class="jn-sc-ys-lbl">Your size <span class="jn-sc-ys-sys">US</span></div>'
        + '<div class="jn-sc-ys-big">' + esc(bra.full) + '</div>'
        + (showNativeHint ? '<div class="jn-sc-ys-hint">= ' + esc(nativeEq) + ' in ' + (nativeSysName[nativeSys] || nativeSys) + ' sizing</div>' : '')
        + (sis.length ? '<div class="jn-sc-ys-sis">Sister sizes: ' + sis.map(function(s){ return '<span>' + esc(s) + '</span>'; }).join('') + '</div>' : '')
        + '<div class="jn-sc-ys-btns">'
        + '<button class="jn-sc-recalc' + (S.showFind ? ' open' : '') + '" onclick="window.jnSC._tf()">Not your size? '
        + '<span class="jn-sc-recalc-ico">' + CHEV + '</span>'
        + '</button>'
        + '<button class="jn-sc-recalc' + (S.fitOpen ? ' open' : '') + '" onclick="window.jnSC._fitTog()">Understanding Fit '
        + '<span class="jn-sc-recalc-ico">' + CHEV + '</span>'
        + '</button>'
        + '</div></div>';
    }

    if (S.showFind || !bra) {
      h += '<div class="jn-sc-find">';
      if (!bra) h += '<div class="jn-sc-find-ttl">Find Your Size</div>';
      if (S.activeTab === 'choice') {
        h += '<div class="jn-sc-cards">'
          + '<div class="jn-sc-card" onclick="window.jnSC._tab(\'enter\')">'
          + '<div class="jn-sc-card-ico">&#10003;</div>'
          + '<div class="jn-sc-card-ttl">I know my size</div>'
          + '<div class="jn-sc-card-sub">Enter your band and cup size directly</div>'
          + '</div>'
          + '<div class="jn-sc-card" onclick="window.jnSC._tab(\'measure\')">'
          + '<div class="jn-sc-card-ico">&#128207;</div>'
          + '<div class="jn-sc-card-ttl">Help me measure</div>'
          + '<div class="jn-sc-card-sub">Find your size with our guided measurement tool</div>'
          + '</div></div>';
      } else if (S.activeTab === 'enter') {
        h += buildEnterForm();
      } else if (S.activeTab === 'measure') {
        h += buildMeasureForm();
      }
      h += '</div>';
    }

    if (S.fitOpen) h += buildFitGuide();

    var manyRows = (S.data.rows || []).length > 8;
    if (manyRows) h += buildFittersNote();
    h += buildChart();
    if (!manyRows) h += buildFittersNote();
    return h;
  }

  function buildEnterForm() {
    var BANDS = [28,30,32,34,36,38,40,42,44,46,48];
    var entSys = S.entrySystem || 'us';
    var cups = entSys === 'uk' ? CUPS_UK : entSys === 'euro' ? CUPS_EU : CUPS;
    var cb = (S.bra && S.bra.band) ? S.bra.band : '';
    // Pre-select cup converted to the chosen entry system so customers see their equivalent
    var storedCup = (S.bra && S.bra.cup) ? S.bra.cup : '';
    var cc = '';
    if (storedCup) {
      if (entSys === 'us')   cc = storedCup;
      else if (entSys === 'uk')   cc = US_UK[storedCup] || '';
      else if (entSys === 'euro') cc = US_EU[storedCup] || '';
    }
    var sysBtns = [['us','US'],['uk','UK / AU'],['euro','European']].map(function(p) {
      return '<button class="jn-sc-ubtn' + (entSys === p[0] ? ' active' : '') + '" onclick="window.jnSC._esys(\'' + p[0] + '\')">' + p[1] + '</button>';
    }).join('');
    return '<button class="jn-sc-back" onclick="window.jnSC._back()">&#8592; Back to options</button>'
      + '<div class="jn-sc-esys-lbl">Enter size as:</div>'
      + '<div class="jn-sc-units" style="margin-bottom:16px">' + sysBtns + '</div>'
      + '<div class="jn-sc-sels">'
      + '<div class="jn-sc-sw"><label>Band</label>'
      + '<select class="jn-sc-sel" id="jnsc-b" onchange="window.jnSC._syncE()">'
      + '<option value="">—</option>'
      + BANDS.map(function(b){ return '<option' + (cb == b ? ' selected' : '') + '>' + b + '</option>'; }).join('')
      + '</select></div>'
      + '<div class="jn-sc-sw"><label>Cup</label>'
      + '<select class="jn-sc-sel" id="jnsc-c" onchange="window.jnSC._syncE()">'
      + '<option value="">—</option>'
      + cups.map(function(c){ return '<option' + (cc === c ? ' selected' : '') + '>' + c + '</option>'; }).join('')
      + '</select></div>'
      + '</div>'
      + '<div class="jn-sc-err" id="jnsc-err"></div>'
      + '<button class="jn-sc-cta" id="jnsc-esave" onclick="window.jnSC._saveE()"' + (cb && cc ? '' : ' disabled') + '>Save My Size</button>';
  }

  function buildMeasureForm() {
    var isCm = S.unit === 'cm';
    var res = S.calcRes;
    return '<button class="jn-sc-back" onclick="window.jnSC._back()">&#8592; Back to options</button>'
      + '<div class="jn-sc-units">'
      + '<button class="jn-sc-ubtn' + (!isCm ? ' active' : '') + '" onclick="window.jnSC._unit(\'in\')">Inches</button>'
      + '<button class="jn-sc-ubtn' + (isCm ? ' active' : '') + '" onclick="window.jnSC._unit(\'cm\')">CM</button>'
      + '</div>'
      + '<div class="jn-sc-imgs">'
      + '<div class="jn-sc-iw"><img src="https://cdn.shopify.com/s/files/1/1658/2831/files/band-measure.png?v=1781363266&width=400" alt="" loading="lazy"><div class="jn-sc-ilbl">Step 1 &ndash; Underbust</div></div>'
      + '<div class="jn-sc-iw"><img src="https://cdn.shopify.com/s/files/1/1658/2831/files/bust-measure.png?v=1781363828&width=400" alt="" loading="lazy"><div class="jn-sc-ilbl">Step 2 &ndash; Bust</div></div>'
      + '</div>'
      + '<div class="jn-sc-inps">'
      + '<div class="jn-sc-iw2"><label>Underbust (' + S.unit + ')</label><input class="jn-sc-inp" type="number" id="jnsc-bv" value="' + esc(S.bandV) + '" placeholder="' + (isCm?'76':'30') + '" step="0.5" oninput="window.jnSC._bv(this.value)"></div>'
      + '<div class="jn-sc-iw2"><label>Bust (' + S.unit + ')</label><input class="jn-sc-inp" type="number" id="jnsc-uv" value="' + esc(S.bustV) + '" placeholder="' + (isCm?'91':'36') + '" step="0.5" oninput="window.jnSC._uv(this.value)"></div>'
      + '</div>'
      + '<div class="jn-sc-err" id="jnsc-merr"></div>'
      + '<button class="jn-sc-cta" onclick="window.jnSC._calc()">Find My Size</button>'
      + (res ? '<div class="jn-sc-res">'
        + '<div class="jn-sc-res-lbl">Your size</div>'
        + '<div class="jn-sc-res-sz">' + esc(res.full) + '</div>'
        + '<div class="jn-sc-res-sub">Band ' + res.band + ' &middot; Cup ' + res.cup + '</div>'
        + sisters(res).map(function(s){ return '<span class="jn-sc-sis-bd">' + esc(s) + '</span>'; }).join('')
        + '</div>' : '');
  }

  /* ─── CHART ──────────────────────────────────────────────────────────────── */
  function buildChart() {
    var data = S.data;
    var rows = sortRows(data.rows || []);
    if (!rows.length) return '';

    var effectiveSys = S.effectiveSys || 'us';
    var hasFits = rows.some(function(r){ return r.f; });

    // Always show native product sizes. For highlighted rows, annotate with US equivalent
    // so the customer knows which size to select without hunting for a converted label.
    var trs = rows.map(function(row) {
      var hl = isHL(row);
      var usEqNote = '';
      if (hl && effectiveSys !== 'us') {
        var usEq = convertBra(row.s, effectiveSys, 'us');
        if (norm(usEq) !== norm(row.s)) usEqNote = '<span class="jn-sc-us-eq">= ' + esc(usEq) + ' US</span>';
      }
      return '<tr' + (hl ? ' class="jn-sc-hl"' : '') + '>'
        + '<td>' + esc(row.s) + usEqNote + (hl ? '<span class="jn-sc-you">You</span>' : '') + '</td>'
        + (hasFits ? '<td>' + esc(row.f) + '</td>' : '')
        + '</tr>';
    }).join('');

    return '<div class="jn-sc-chart">'
      + '<div class="jn-sc-chart-ttl">Size Chart</div>'
      + '<div class="jn-sc-tscroll"><table class="jn-sc-tbl">'
      + '<thead><tr><th>Size</th>' + (hasFits ? '<th>Fits</th>' : '') + '</tr></thead>'
      + '<tbody>' + trs + '</tbody></table></div></div>';
  }

  /* ─── FITTER'S NOTES ─────────────────────────────────────────────────────── */
  function buildFittersNote() {
    if (!S.data.fnotes) return '';
    return '<div class="jn-sc-fnote">'
      + '<div class="jn-sc-fnote-lbl">Fitter\'s Notes</div>'
      + '<blockquote class="jn-sc-fnote-q">' + esc(S.data.fnotes) + '</blockquote>'
      + '</div>';
  }

  /* ─── FIT GUIDE ─────────────────────────────────────────────────────────── */
  function buildFitGuide() {
    var tips = [
      'Round your band <strong>down</strong> if you\'re between sizes — US bands are even; rounding up just loosens the back.',
      'Measure in a light, unlined bra. Each layer of padding adds roughly &frac12; cup to your bust measurement.',
      'Your shape affects fit in ways the tape can\'t see. Use the measurement as a starting point, not a law.',
      'If you\'re asymmetric (most people are), fit to the larger side and use a removable insert for the other.'
    ];
    var cards = SHAPES.map(function(sh) {
      return '<div class="jn-sc-sh-card">'
        + '<div class="jn-sc-sh-iw"><img class="jn-sc-sh-img" src="' + SHAPE_BASE + sh.f + '&width=160" alt="' + esc(sh.n) + '" loading="lazy"></div>'
        + '<div class="jn-sc-sh-name">' + esc(sh.n) + '</div>'
        + '<div class="jn-sc-sh-tip">' + sh.t + '</div>'
        + '</div>';
    }).join('');
    return '<div class="jn-sc-fit-body">'
      + '<div class="jn-sc-fit-sl">Why measurements aren\'t everything</div>'
      + '<ul class="jn-sc-fit-tips">' + tips.map(function(t){ return '<li>' + t + '</li>'; }).join('') + '</ul>'
      + '<div class="jn-sc-fit-sl" style="margin-top:16px">Your breast shape</div>'
      + '<div class="jn-sc-shapes">' + cards + '</div>'
      + '</div>';
  }

  /* ─── PANTY ──────────────────────────────────────────────────────────────── */
  function buildPanty() {
    var rows = sortRows(S.data.rows || []);
    var hasFitsData = rows.some(function(r) { return r.f && r.f.trim(); });
    var hasDress = isDressSize(rows) || isDressFits(rows);
    var h = '';

    if (hasDress) {
      // Hip-only calculator for dress-sized underwear (e.g. "4-6", "8-10" sizes)
      h += buildDressCalc(true);
      h += buildDressChart(rows);
    } else {
      h += '<div class="jn-sc-how" style="border-top:none;margin-top:0;padding-top:0">'
        + '<div class="jn-sc-how-hd" onclick="window.jnSC._howTog()">'
        + '<span class="jn-sc-how-ttl">How to Measure</span>'
        + '<span class="jn-sc-how-ico' + (S.howOpen ? ' open' : '') + '">' + CHEV + '</span>'
        + '</div>';
      if (S.howOpen) {
        h += '<div class="jn-sc-how-body"><div class="jn-sc-how-pair">'
          + '<div><div class="jn-sc-how-lbl">Waist</div>'
          + '<p class="jn-sc-how-p">Locate your natural waist by gently bending to one side — the crease that forms marks the right spot. Wrap a soft tape measure around this point, keeping it parallel to the floor with one finger of ease between tape and body.</p></div>'
          + '<div><div class="jn-sc-how-lbl">Hip</div>'
          + '<p class="jn-sc-how-p">Stand upright with feet together. Wrap the tape around the fullest part of your hips and seat, approximately 7–9 inches below your natural waist, keeping the tape level and parallel to the floor.</p></div>'
          + '</div></div>';
      }
      h += '</div>';

      if (hasFitsData) {
        var showMeas = isDressFits(rows);
        h += '<div class="jn-sc-chart" style="border-top:none;padding-top:4px">'
          + '<div class="jn-sc-tscroll"><table class="jn-sc-tbl">'
          + '<thead><tr><th>Size</th><th>Fits US</th>'
          + (showMeas ? '<th>Waist (in)</th><th>Hip (in)</th>' : '')
          + '</tr></thead>'
          + '<tbody>' + rows.map(function(r) {
            var mHtml = '';
            if (showMeas) {
              var meas = dressFitsMeasurements(r.f);
              mHtml = meas
                ? '<td>' + meas.waist + '</td><td>' + meas.hip + '</td>'
                : '<td>—</td><td>—</td>';
            }
            return '<tr><td>' + esc(r.s) + '</td><td>' + esc(r.f) + '</td>' + mHtml + '</tr>';
          }).join('') + '</tbody></table></div></div>';
      } else {
        h += buildPantyFallbackChart();
      }
    }

    h += buildFittersNote();
    return h;
  }

  function buildPantyFallbackChart() {
    var SIZES = [
      { sz:'XX-Small', us:'00',    waist:'23"',        hip:'33.5"' },
      { sz:'X-Small',  us:'0–2',  waist:'24"–25"',   hip:'34.5"–35.5"' },
      { sz:'Small',    us:'4–6',  waist:'26"–27"',   hip:'36.5"–37.5"' },
      { sz:'Medium',   us:'8–10', waist:'28"–29"',   hip:'38.5"–39.5"' },
      { sz:'Large',    us:'12–14',waist:'30.5"–32"', hip:'41"–42.5"' },
      { sz:'X-Large',  us:'16–18',waist:'34"–36"',   hip:'44.5"–46.5"' },
      { sz:'XX-Large', us:'20',    waist:'38"',        hip:'48.5"' }
    ];
    return '<div class="jn-sc-chart" style="border-top:none;padding-top:4px">'
      + '<div class="jn-sc-chart-ttl">Panty Sizing Guide</div>'
      + '<div class="jn-sc-tscroll"><table class="jn-sc-tbl">'
      + '<thead><tr><th>Size</th><th>Fits US</th><th>Waist</th><th>Hip</th></tr></thead>'
      + '<tbody>' + SIZES.map(function(r){
        return '<tr><td>' + r.sz + '</td><td>' + r.us + '</td><td>' + r.waist + '</td><td>' + r.hip + '</td></tr>';
      }).join('') + '</tbody></table></div></div>';
  }

  /* ─── DRESS SIZE CALCULATOR ─────────────────────────────────────────────── */
  function buildDressCalc(hipOnly) {
    var isCm = S.dressUnit === 'cm';
    var u = isCm ? 'cm' : 'in';
    var res = S.dressRes;
    var isOpen = S.dressCalcOpen;

    var h = '<div class="jn-sc-how" style="border-top:none;margin-top:0;padding-top:0">'
      + '<div class="jn-sc-how-hd" onclick="window.jnSC._drToggle()" style="cursor:pointer">'
      + '<span class="jn-sc-how-ttl">Find Your Size</span>'
      + '<span class="jn-sc-how-ico' + (isOpen ? ' open' : '') + '">' + CHEV + '</span>'
      + '</div>';

    if (!isOpen) { h += '</div>'; return h; }

    h += '<div class="jn-sc-find" style="padding-top:8px;margin-top:0">'
      + '<div class="jn-sc-units">'
      + '<button class="jn-sc-ubtn' + (!isCm ? ' active' : '') + '" onclick="window.jnSC._dunit(\'in\')">Inches</button>'
      + '<button class="jn-sc-ubtn' + (isCm ? ' active' : '') + '" onclick="window.jnSC._dunit(\'cm\')">CM</button>'
      + '</div>';

    if (hipOnly) {
      h += '<div style="max-width:220px;margin-bottom:14px">'
        + '<div class="jn-sc-iw2">'
        + '<label>Hip (' + u + ')</label>'
        + '<input class="jn-sc-inp" type="number" id="jnsc-dr-hip" value="' + esc(S.dressHip) + '" placeholder="' + (isCm ? '97' : '38') + '" step="0.5" oninput="window.jnSC._dhip(this.value)">'
        + '<p class="jn-sc-dr-tip">Stand with feet together. Measure around the fullest part of your hips and seat, 7–9 inches below your natural waist.</p>'
        + '</div></div>';
    } else {
      h += '<div class="jn-sc-inps jn-sc-inps-3">'
        + '<div class="jn-sc-iw2"><label>Bust (' + u + ')</label>'
        + '<input class="jn-sc-inp" type="number" id="jnsc-dr-bust" value="' + esc(S.dressBust) + '" placeholder="' + (isCm ? '89' : '35') + '" step="0.5" oninput="window.jnSC._dbust(this.value)">'
        + '<p class="jn-sc-dr-tip">Measure around the fullest part of your bust.</p>'
        + '</div>'
        + '<div class="jn-sc-iw2"><label>Waist (' + u + ')</label>'
        + '<input class="jn-sc-inp" type="number" id="jnsc-dr-waist" value="' + esc(S.dressWaist) + '" placeholder="' + (isCm ? '71' : '28') + '" step="0.5" oninput="window.jnSC._dwaist(this.value)">'
        + '<p class="jn-sc-dr-tip">Measure at your natural waist, the narrowest point.</p>'
        + '</div>'
        + '<div class="jn-sc-iw2"><label>Hip (' + u + ')</label>'
        + '<input class="jn-sc-inp" type="number" id="jnsc-dr-hip" value="' + esc(S.dressHip) + '" placeholder="' + (isCm ? '97' : '38') + '" step="0.5" oninput="window.jnSC._dhip(this.value)">'
        + '<p class="jn-sc-dr-tip">Measure around the fullest part of your hips.</p>'
        + '</div></div>';
    }

    h += '<div class="jn-sc-err" id="jnsc-dr-err"></div>'
      + '<button class="jn-sc-cta" onclick="window.jnSC._dcalc()">Find My Size</button>';

    if (res) {
      h += '<div class="jn-sc-res">'
        + '<div class="jn-sc-res-lbl">Your size</div>'
        + '<div class="jn-sc-res-sz">' + esc(res.matched || (res.sizeNum !== null ? 'Size ' + res.sizeNum : '—')) + '</div>'
        + '<div class="jn-sc-res-sub">'
        + (res.matched
            ? 'US size ' + res.sizeNum + ' &middot; highlighted in the chart below'
            : 'US size ' + res.sizeNum + ' is outside the listed ranges')
        + '</div></div>';
    }

    h += '</div></div>';
    return h;
  }

  // Size chart for dress-sized products, with optional highlight from dressRes
  function buildDressChart(rows) {
    var hasFits = rows.some(function(r) { return r.f; });
    var dressFitsMode = hasFits && isDressFits(rows);
    var trs = rows.map(function(row) {
      var hl = S.dressRes && S.dressRes.matched && norm(row.s) === norm(S.dressRes.matched);
      var measHtml = '';
      if (dressFitsMode) {
        var meas = dressFitsMeasurements(row.f);
        measHtml = meas
          ? '<td>' + meas.waist + '</td><td>' + meas.hip + '</td>'
          : '<td>—</td><td>—</td>';
      }
      return '<tr' + (hl ? ' class="jn-sc-hl"' : '') + '>'
        + '<td>' + esc(row.s) + (hl ? '<span class="jn-sc-you">You</span>' : '') + '</td>'
        + (hasFits ? '<td>' + esc(row.f) + '</td>' : '')
        + measHtml
        + '</tr>';
    }).join('');
    var hdr = '<th>Size</th>';
    if (hasFits) {
      hdr += '<th>' + (dressFitsMode ? 'Fits US' : 'Fits Bra Size') + '</th>';
      if (dressFitsMode) hdr += '<th>Waist (in)</th><th>Hip (in)</th>';
    }
    return '<div class="jn-sc-chart" style="padding-top:6px">'
      + '<div class="jn-sc-chart-ttl">Size Chart</div>'
      + '<div class="jn-sc-tscroll"><table class="jn-sc-tbl">'
      + '<thead><tr>' + hdr + '</tr></thead>'
      + '<tbody>' + trs + '</tbody></table></div></div>';
  }

  /* ─── NON-BRA ────────────────────────────────────────────────────────────── */
  function buildNonBra() {
    var rows = sortRows(S.data.rows || []);
    if (!rows.length) return '<p class="jn-sc-empty">No size information available.</p>';

    if (isDressSize(rows) || isDressFits(rows)) {
      return buildDressCalc(false) + buildDressChart(rows) + buildFittersNote();
    }

    var hasFits = rows.some(function(r){ return r.f; });
    return '<div class="jn-sc-chart" style="border-top:none;padding-top:4px">'
      + '<div class="jn-sc-tscroll"><table class="jn-sc-tbl">'
      + '<thead><tr><th>Size</th>' + (hasFits ? '<th>Fits</th>' : '') + '</tr></thead>'
      + '<tbody>' + rows.map(function(r){
        return '<tr><td>' + esc(r.s) + '</td>' + (hasFits ? '<td>' + esc(r.f) + '</td>' : '') + '</tr>';
      }).join('') + '</tbody></table></div></div>'
      + buildFittersNote();
  }

  /* ─── ACTIONS ────────────────────────────────────────────────────────────── */
  function _fitTog() { S.fitOpen = !S.fitOpen; render(); }
  function _howTog() { S.howOpen = !S.howOpen; render(); }
  function _tf() {
    S.showFind = !S.showFind;
    if (S.showFind) S.activeTab = 'choice';
    render();
  }
  function _tab(t)  { S.activeTab = t; render(); }
  function _back()  { S.activeTab = 'choice'; render(); }
  function _sys(t)  { S.sysTab = t; render(); } // kept for backwards compat, tabs no longer shown
  function _esys(s) { S.entrySystem = s; render(); }
  function _unit(u) {
    var bv = document.getElementById('jnsc-bv'), uv = document.getElementById('jnsc-uv');
    if (bv) S.bandV = bv.value;
    if (uv) S.bustV = uv.value;
    S.unit = u;
    render();
  }
  function _bv(v) { S.bandV = v; }
  function _uv(v) { S.bustV = v; }
  function _syncE() {
    var b = document.getElementById('jnsc-b'), c = document.getElementById('jnsc-c');
    var btn = document.getElementById('jnsc-esave');
    if (btn) btn.disabled = !(b && b.value && c && c.value);
  }
  function _saveE() {
    var b = document.getElementById('jnsc-b'), c = document.getElementById('jnsc-c');
    if (!b || !b.value || !c || !c.value) return;
    var entSys = S.entrySystem || 'us';
    var band = parseInt(b.value, 10);
    var cup = c.value;
    // Convert cup to US before storing — cookie always holds US sizing
    if (entSys === 'uk')   cup = UK_US[cup] || cup;
    if (entSys === 'euro') cup = EU_US[cup] || cup;
    var sz = { band: band, cup: cup, full: band + cup };
    saveBra(sz);
    S.bra = sz; S.showFind = false; S.calcRes = null; S.activeTab = 'choice';
    kTrack('Quiz - Bra Size Set', { size: sz.full, band: sz.band, cup: sz.cup, method: 'entered' });
    document.dispatchEvent(new CustomEvent('jnBraSizeSet', { bubbles: true }));
    render();
  }
  function _calc() {
    var bv = document.getElementById('jnsc-bv'), uv = document.getElementById('jnsc-uv');
    if (bv) S.bandV = bv.value;
    if (uv) S.bustV = uv.value;
    var err = document.getElementById('jnsc-merr');
    if (!S.bandV || !S.bustV) {
      if (err) err.textContent = 'Please enter both measurements.';
      return;
    }
    var sz = calcBra(S.bandV, S.bustV, S.unit);
    saveBra(sz);
    S.bra = sz; S.calcRes = sz;
    kTrack('Quiz - Bra Size Set', { size: sz.full, band: sz.band, cup: sz.cup, method: 'measured' });
    document.dispatchEvent(new CustomEvent('jnBraSizeSet', { bubbles: true }));
    render();
  }

  function _drToggle() { S.dressCalcOpen = !S.dressCalcOpen; render(); }

  /* ─── DRESS CALC ACTIONS ─────────────────────────────────────────────────── */
  function _dunit(u) {
    var bEl = document.getElementById('jnsc-dr-bust');
    var wEl = document.getElementById('jnsc-dr-waist');
    var hEl = document.getElementById('jnsc-dr-hip');
    if (bEl) S.dressBust  = bEl.value;
    if (wEl) S.dressWaist = wEl.value;
    if (hEl) S.dressHip   = hEl.value;
    S.dressUnit = u;
    render();
  }
  function _dbust(v)  { S.dressBust  = v; }
  function _dwaist(v) { S.dressWaist = v; }
  function _dhip(v)   { S.dressHip   = v; }
  function _dcalc() {
    var bEl = document.getElementById('jnsc-dr-bust');
    var wEl = document.getElementById('jnsc-dr-waist');
    var hEl = document.getElementById('jnsc-dr-hip');
    if (bEl) S.dressBust  = bEl.value;
    if (wEl) S.dressWaist = wEl.value;
    if (hEl) S.dressHip   = hEl.value;
    var isCm = S.dressUnit === 'cm';
    var hip   = parseFloat(S.dressHip)   || 0;
    var bust  = parseFloat(S.dressBust)  || 0;
    var waist = parseFloat(S.dressWaist) || 0;
    if (isCm) { hip /= 2.54; bust /= 2.54; waist /= 2.54; }
    var err = document.getElementById('jnsc-dr-err');
    if (hip <= 0) {
      if (err) err.textContent = 'Please enter your hip measurement.';
      return;
    }
    if (err) err.textContent = '';
    var sizeNum = calcDress(bust, waist, hip);
    var _rows = S.data.rows || [];
    var _matched = isDressSize(_rows) ? matchDressRow(_rows, sizeNum) : matchDressFitsRow(_rows, sizeNum);
    S.dressRes = { sizeNum: sizeNum, matched: _matched };

    var pantySize = DRESS_TO_PANTY[sizeNum] || null;
    if (pantySize && S.data.isPanty) {
      var cookieVal = JSON.stringify({ dressSize: sizeNum, pantySize: pantySize });
      setCk('jfq_dress_sz', cookieVal, 365);
      try { localStorage.setItem('jfq_dress_sz', cookieVal); } catch(e) {}
      kTrack('Panty Size Set', { dress_size: sizeNum, panty_size: pantySize, method: 'measured' });
      document.dispatchEvent(new CustomEvent('jnPantySizeSet', { bubbles: true }));
    }

    render();
  }

  /* ─── MODAL ──────────────────────────────────────────────────────────────── */
  var _ov = null;

  function injectCSS() {
    if (document.getElementById('jn-sc-css')) return;
    var s = document.createElement('style');
    s.id = 'jn-sc-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function _onKey(e) { if (e.key === 'Escape') closeModal(); }

  function openModal(wrap) {
    var sc = wrap.querySelector('.jn-sc-data');
    if (!sc) return;
    var data;
    try { data = JSON.parse(sc.textContent); } catch(e) { return; }

    var bra = data.isBra ? getBra() : null;
    S = {
      data: data, bra: bra,
      showFind: !bra, activeTab: 'choice',
      sysTab: 'us',
      effectiveSys: autoDetectSys(data.rows || []) || detectSysFromFits(data.rows || []) || 'us',
      entrySystem: 'us',
      unit: 'in', bandV: '', bustV: '',
      calcRes: null, howOpen: false, fitOpen: false,
      dressUnit: 'in', dressBust: '', dressWaist: '', dressHip: '', dressRes: null,
      dressCalcOpen: false
    };

    injectCSS();

    // Compensate for scrollbar width to prevent layout shift
    var sw = window.innerWidth - document.documentElement.clientWidth;
    if (sw > 0) document.body.style.paddingRight = sw + 'px';
    document.body.style.overflow = 'hidden';

    _ov = document.createElement('div');
    _ov.className = 'jn-sc-ov';
    _ov.innerHTML = '<div class="jn-sc-panel" role="dialog" aria-modal="true" aria-label="Size &amp; Fit">'
      + '<div class="jn-sc-hd"><span class="jn-sc-ttl">Size &amp; Fit</span>'
      + '<button class="jn-sc-x" onclick="window.jnSC.close()" aria-label="Close">&times;</button></div>'
      + '<div class="jn-sc-body" id="jn-sc-app"></div>'
      + '</div>';
    // Always mount on body so position:fixed works correctly (mounting inside
    // quick-buy-modal caused the overlay to be clipped by the modal's
    // overflow:auto / isolation:isolate shadow part). Click and focusin
    // propagation are stopped below so the quick-buy focus-trap is unaffected.
    document.body.appendChild(_ov);
    document.addEventListener('keydown', _onKey);
    _ov.addEventListener('click', function(e) {
      e.stopPropagation();
      if (e.target === _ov) closeModal();
    });
    // focusin bubbles and is caught by the quick-buy-modal's document-level
    // focus-trap. Stop it here so the quick-buy doesn't close when the user
    // interacts with size-help elements (which are outside the modal DOM).
    _ov.addEventListener('focusin', function(e) { e.stopPropagation(); });

    // Pause the quick-buy-modal's FocusTrap while size-help is open so it doesn't
    // close the modal when the user clicks inside the size-help overlay (which is
    // outside the modal's DOM). Unpaused in closeModal().
    var _jnQbm = document.querySelector('quick-buy-modal[open]');
    if (_jnQbm) {
      try { _jnQbm.focusTrap.pause(); } catch(e) {}
      _jnQbm._jnSCPaused = true;
    }

    render();
    requestAnimationFrame(function(){ _ov.classList.add('open'); });
  }

  function closeModal() {
    if (!_ov) return;
    var el = _ov; _ov = null;
    el.classList.remove('open');
    document.removeEventListener('keydown', _onKey);
    // Unpause the quick-buy-modal's FocusTrap now that size-help is closing.
    var _jnQbm = document.querySelector('quick-buy-modal');
    if (_jnQbm && _jnQbm._jnSCPaused) {
      try { _jnQbm.focusTrap.unpause(); } catch(e) {}
      delete _jnQbm._jnSCPaused;
    }
    setTimeout(function() {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      if (el.parentNode) el.parentNode.removeChild(el);
    }, 350);
  }

  /* ─── DELEGATE ───────────────────────────────────────────────────────────── */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest && e.target.closest('.jn-sc-btn');
    if (!btn) return;
    var wrap = btn.closest('.jn-sc-wrap');
    if (wrap) openModal(wrap);
  });

  /* ─── PUBLIC API ─────────────────────────────────────────────────────────── */
  window.jnSC = {
    open: openModal, close: closeModal,
    _fitTog: _fitTog, _howTog: _howTog, _tf: _tf, _tab: _tab, _back: _back, _sys: _sys, _esys: _esys,
    _unit: _unit, _bv: _bv, _uv: _uv, _syncE: _syncE, _saveE: _saveE, _calc: _calc,
    _dunit: _dunit, _dbust: _dbust, _dwaist: _dwaist, _dhip: _dhip, _dcalc: _dcalc,
    _drToggle: _drToggle
  };

  // Inject CSS immediately so .jn-sc-btn is styled before any click
  injectCSS();

})();
